import { useAuth } from "@assetwatch/auth";
import { AppShellContent } from "@assetwatch/ui";
import { createFileRoute } from "@tanstack/react-router";
import { AppNotFoundContent } from "../components/AppNotFound";
import { useFeatureFlags } from "../components/LaunchDarkly/useFeatureFlags";
import { canAccessMotionAmplification } from "../lib/access";
import { useMotionAmplificationJobsQuery } from "../queries/useMotionAmplificationJobsQuery";
import { MotionAmplificationScreen } from "../screens/MotionAmplificationScreen";

export const Route = createFileRoute("/_app/motion-amplification")({
  component: MotionAmplificationRoute,
});

function MotionAmplificationRoute() {
  const { user } = useAuth();
  const flags = useFeatureFlags();

  if (!canAccessMotionAmplification({ flags, user })) {
    return (
      <AppShellContent>
        <AppNotFoundContent />
      </AppShellContent>
    );
  }

  return <AuthorizedMotionAmplificationRoute />;
}

function AuthorizedMotionAmplificationRoute() {
  const jobsQuery = useMotionAmplificationJobsQuery();

  return <MotionAmplificationScreen jobsQuery={jobsQuery} />;
}
